import React, {Component} from "react";
import { Chip } from "@mui/material";
import { EPaymentMethod } from "../../../classes/types/order/order";
import { CreditCard, AccountBalance } from "@mui/icons-material";

interface props {
    paymentMethod: string;
}

interface state {}

export default class PaymentMethodBadge extends Component<props, state> {

    constructor(props: props) {
        super(props);

        this.state = {};
    }

    render() {
        return(
            <Chip
                icon={this.getIcon()}
                label={this.getText()}
                style={{backgroundColor: this.getBackgroundColor(), color: "white"}}
            />
        );
    }

    getBackgroundColor = () => {
        return "#03a9f4";
    }

    getText = () => {
        return this.props.paymentMethod;
    }

    getIcon = () => {
        return (<AccountBalance style={{color: "white"}} />);
    }

}